export default __webpack_public_path__ + "static/media/logo-department-interior.12874f48.png";